<template>
  <div>
    <div class="table-responsive bg-white">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="bg-primary">Fabric NO</th>
            <th class="bg-primary">Order Amount</th>
            <th class="bg-primary">Delivered Amount</th>
            <th class="bg-primary">Leftover Amout</th>
            <th class="bg-primary">Unit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fabric in order.fabrics" :key="fabric.id">
            <td>{{ Fabric.getCode(fabric.id) }}</td>
            <td>{{ ezy.comma(fabric.amount_ordered) }}</td>
            <td>{{ ezy.comma(fabric.amount_delivered) }}</td>
            <td>
              {{ ezy.comma(fabric.amount_ordered - fabric.amount_delivered) }}
            </td>
            <td>
              <span v-if="fabric.unit == 'm'">Meter</span>
              <span v-if="fabric.unit == 'y'">Yard</span>
              <span v-if="fabric.unit == 'kg'">Kilogram</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Delivery Details -->
    <div id="order-table" class="grid shadow bg-white mt-10">
      <div class="grid-title">
        <h4 class="text-black text-bold">
          <i
            v-if="
              order.fabric_order_deliveries &&
              order.fabric_order_deliveries.length == 0
            "
            class="fa text-success fa-circle-o"
          ></i>
          <i
            v-if="
              order.fabric_order_deliveries &&
              order.fabric_order_deliveries.length > 0
            "
            class="fa text-success fa-check-circle"
          ></i>
          Delivery Details
        </h4>
        <router-link
          class="btn btn-primary btn-small float-right"
          style="margin-right: 10px"
          v-if="!isReadOnlyUser"
          :to="{
            name: 'fabric_order_delivery_create',
            params: { order_id: order.id },
          }"
        >
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          Create Delivery
        </router-link>
      </div>
      <div class="grid-body">
        <template
          v-for="(delivery, deliveryIndex) in order.fabric_order_deliveries"
        >
          <div class="well well-sm" :key="deliveryIndex">
            <div class="row">
              <div class="col-sm-3">
                <h5 class="semi-bold">
                  {{ delivery.delivery_reference }}
                  <h5>{{ ezy.date(delivery.created_at) }}</h5>
                </h5>
              </div>
              <div class="col-sm-9 text-right">
                <router-link
                  class="btn btn-primary btn-small"
                  style="margin-right: 5px"
                  :to="{
                    name: 'fabric_order_delivery_update',
                    params: { order_id: order.id, delivery_id: delivery.id },
                  }"
                >
                  Edit Delivery</router-link
                >
                <button
                  class="btn btn-danger btn-small"
                  @click="deleteDelivery(order.id, delivery.id)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>

            <table class="table table-condensed p-0">
              <thead>
                <tr>
                  <th></th>
                  <th>Fabric ID</th>
                  <th>Fabric Name</th>
                  <th>Order Amount</th>
                  <th>Delivery Amount</th>
                  <th>Unit</th>
                  <th>Unit Price</th>
                  <th>Currency</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(fabric, fabricIndex) in delivery.fabrics">
                  <tr :key="fabricIndex">
                    <td class="bg-info col-sm-1">
                      <a
                        class="fabric-toggle"
                        v-if="fabric.expanded"
                        @click="toggleFabricRows(fabric)"
                      >
                        <span class="fa fa-chevron-down"></span>
                      </a>
                      <a
                        class="fabric-toggle"
                        v-if="!fabric.expanded"
                        @click="toggleFabricRows(fabric)"
                      >
                        <span class="fa fa-chevron-right"></span>
                      </a>
                    </td>
                    <td class="bg-info">{{ fabric.fabric_id }}</td>
                    <td class="bg-info">{{ fabric.fabric_name }}</td>
                    <td class="bg-info col-sm-2">{{ ezy.comma(fabric.order_amount) }}</td>
                    <td class="bg-info col-sm-2">
                      {{ ezy.comma(fabric.delivery_amount.this_delivery) }}
                    </td>
                    <td class="bg-info">{{ fabric.unit }}</td>
                    <td class="bg-info">{{ ezy.comma(fabric.unit_price) }}</td>
                    <td class="bg-info">{{ fabric.currency }}</td>
                    <td class="bg-info">
                      {{ formatAmount(fabric.total_price) }}
                    </td>
                  </tr>
                  <tr
                    v-for="(roll, rollIndex) in fabric.rolls"
                    v-if="fabric.expanded"
                  >
                    <td class="bg-white"></td>
                    <td class="bg-white" colspan="2">#{{ roll.roll_code }}</td>
                    <td class="bg-white col-sm-2">-</td>
                    <td class="bg-white col-sm-2">{{ getOriginalAmount(fabric, roll) }}</td>
                    <td class="bg-white">{{ fabric.unit }}</td>
                    <td class="bg-white">{{ fabric.unit_price }}</td>
                    <td class="bg-white">{{ fabric.currency }}</td>
                    <td class="bg-white">
                      {{ formatAmount(getOriginalAmount(fabric, roll) * fabric.unit_price) }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
    <!-- Delivery Details -->
  </div>
</template>


<script>
import Fabric from "@/pages/Tools/Fabric";
export default {
  data() {
    return {
      order: { fabrics: [] },
      isReadOnlyUser: false,
      Fabric,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getPageData();
  },
  methods: {
    formatAmount(amount) {
      return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },

    /**
     * Base Order Methods
     */
    async getPageData(orderId) {
      let results = await axios({
        method: "get",
        url: "/v2/fabrics/orders/" + this.$route.params.order_id + "/edit",
      });
      this.order = results.data.data.order;
    },

    toggleFabricRows(fabric) {
      let currentStatus = fabric.expanded;
      fabric.expanded = !currentStatus;
    },

    async deleteDelivery(orderId, deliveryId) {
      let res = await Swal.fire({
        title: "Are you sure you want to delete this delivery?",
        html:
          "<span class='text-danger'>If any rolls in the delivery have been withdrawn from the warehouse, this operation will fail!</span>",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete Delivery",
      });

      if (res.value) {
        try {
          await axios({
            method: "delete",
            url: "/v2/fabrics/order/" + orderId + "/delivery/" + deliveryId,
          });
          Swal.fire("Success!", "Delivery deleted!", "success");
          // @todo this is lazy, let's make a method just
          // for updating deliveries!!!
          this.getPageData(orderId);
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            let errors = error.response.data.errors;
            Swal.fire(
              "Error!",
              "Could not delete Delivery!<p><small>" +
                errors.join("</br>") +
                "</small></p>",
              "error"
            );
          }
        }
      }
    },
    /**
     * Get the non-converted amount of the delivery
     */ 
    getOriginalAmount(fabric, roll) {
      return fabric.is_jersey_fabric ? roll.knit_weight : roll.length;
    }
  },
};
</script>
